import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CaConfigComponent} from "./component/protected-components/config/ca-config.component";
import {CaAssessmentTypeObjectComponent} from "./component/object-components/ca-assessment-type-object-component/ca-assessment-type-object.component";
import {CaAssessmentTypeObjectPage} from "./page/object/assessment-type/ca-assessment-type-object.page";
import {CA_ENTITY_PROVIDER} from "./ca.entity-provider";
import {CoreModule} from "../../core/core.module";
import {CA_TEST_PROVIDERS} from "./test/ca-test-definition";

// PrimeNG Modules
import {ButtonModule} from 'primeng/button';
import {CheckboxModule} from 'primeng/checkbox';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {MvsConfirmationService} from '../../core/shared/service/confirmation/mvs-confirmation.service';


// Dynamic Module Interface
import {DynamicModule} from '../../core/shared/interface/dynamic-module.interface';
import {ModuleRegistryService} from '../../core/shared/interface/module-registration.service';

@NgModule({
    declarations: [
        CaConfigComponent,
        CaAssessmentTypeObjectComponent,
        CaAssessmentTypeObjectPage,
    ],
    exports: [
        CaConfigComponent,
        CaAssessmentTypeObjectComponent,
        CaAssessmentTypeObjectPage,
    ],
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        ButtonModule,
        CheckboxModule,
        ProgressSpinnerModule,
        ConfirmDialogModule
    ],
    providers: [
        CA_ENTITY_PROVIDER,
        CA_TEST_PROVIDERS,
        {provide: ConfirmationService, useClass: MvsConfirmationService}
    ]
})
export class CaModule implements DynamicModule {

    alias = 'ca';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return null;
    }

    getStatisticsComponent() {
        return null;
    }
}
